import React from "react";
import { Modal, Button, Text } from "@nextui-org/react";
import ReactJson from "react-json-view";

export default function ResultsInfo({
  children,
  makeVisible = false,
  setVisible = () => null,
  data,
}) {
  const closeHandler = () => {
    setVisible(false);
    console.log("closed");
  };
  return (
    <div>
      {children}
      <Modal
        closeButton
        blur
        aria-labelledby="modal-title"
        open={makeVisible}
        onClose={closeHandler}
        width="1300px"
        scroll
      >
        <Modal.Header>
          <Text id="modal-title" size={18} b>
            Result Log
          </Text>
        </Modal.Header>
        <Modal.Body>
          <ReactJson src={data} />
        </Modal.Body>
        <Modal.Footer>
          <Button auto onPress={closeHandler}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
